const KEY = "slusariuc_cookie_consent";
export const CONSENT_VERSION = 1;
export const OPEN_EVENT = "open-cookie-settings";

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c?.version === CONSENT_VERSION ? c : null;
  } catch {
    return null;
  }
};

export const saveConsent = (prefs) => {
  const c = { version: CONSENT_VERSION, necessary: true, statistics: !!prefs.statistics, marketing: !!prefs.marketing, date: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  return c;
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));
